import { NodeSelection } from '@tiptap/pm/state';

export function resolveContentInsertionTarget(editor, profile, explicitTarget) {
  if (!editor) return null;
  if (explicitTarget) return explicitTarget;
  const selection = editor.state.selection;
  if (selection instanceof NodeSelection && !selection.node.isLeaf && profile.blocks.some((block) => block.allowedParents.includes(selection.node.type.name))) {
    return { position: selection.from + selection.node.nodeSize - 1, parentType: selection.node.type.name };
  }
  const resolved = editor.state.doc.resolve(selection.to);
  return resolved.parent.isTextblock
    ? { position: resolved.after(resolved.depth), parentType: resolved.node(resolved.depth - 1).type.name }
    : { position: selection.to, parentType: resolved.parent.type.name };
}

export function contentBlockInsertionAllowed(editor, block, target) {
  if (!editor || !target) return false;
  const parent = editor.state.doc.resolve(target.position).parent;
  if (!block.allowedParents.includes(target.parentType || parent.type.name)) return false;
  if (parent.type.name !== 'container' || !parent.childCount) return true;
  let hasColumns = false;
  let hasOtherBlocks = false;
  parent.forEach((child) => { if (child.type.name === 'column') hasColumns = true; else hasOtherBlocks = true; });
  return block.type === 'column' ? !hasOtherBlocks : !hasColumns;
}
